import * as _ from 'lodash';
import * as api from './../api/api.service';

import { DataSet, Puck } from './impact.type';
import { Facility, MemberImpact } from './../api/buyers.service';

export default function SellerImpactFactory(
  $log,
  $q,
  $http,
  jsendHttpInterceptor,
  colors,
  api: api.IApiService
) {
  'use strict';
  'ngInject';

  // var aptitudePositiveColor = colors.aptGreen;
  var aptitudeNegativeColor = colors.aptOrange;

  function fixNullCategorySpendNumbers(facility) {
    var categorySpend = facility.categorySpend;

    categorySpend.categoryPotentialSpend =
      categorySpend.categoryPotentialSpend || 0;
    categorySpend.categoryPotentialSpend =
      categorySpend.categoryPotentialSpend || 0;
    categorySpend.categorySavings = categorySpend.categorySavings || 0;
    categorySpend.crossReferenceSpend = categorySpend.crossReferenceSpend || 0;
    categorySpend.last12monthSpend = categorySpend.last12monthSpend || 0;
    categorySpend.next12monthSpend = categorySpend.next12monthSpend || 0;
    categorySpend.spendWithSeller = categorySpend.spendWithSeller || 0;
  }

  return {
    getRfpDetails: function (rfpId) {
      return api.rfps.getRfp(rfpId, true);
    },

    // Exposed only for testing and not intended for direct calls.
    _getPricingComparison: function (
      rfpId: number,
      sellerId: string,
      partnerId: string,
      priceType: string,
      duration: number,
      usePrimaryCrossReferences: boolean = false
    ) {
      console.warn(
        'TODO: Move the pricingcomparison API call to the api module'
      );
      return $http.get(
        `/aptitude/api/rfps/${rfpId}/sellers/${sellerId}/pricingcomparison`,
        {
          params: {
            partnerId,
            priceType,
            duration,
            usePrimaryCrossReferences
          }
        }
      );
    },

    _getPricingBenchmarks: function (
      rfpId,
      sellerId,
      memberId,
      priceType,
      duration,
      marketShare
    ) {
      console.warn(
        'TODO: Move the pricingbenchmarks API call to the api module'
      );
      return $http.get(
        `/aptitude/api/rfps/${rfpId}/sellers/${sellerId}/pricingbenchmarks`,
        {
          params: {
            partnerId: memberId,
            priceType,
            duration,
            marketShare
          }
        }
      );
    },

    _updateBenchmarksGraphWithBenchmarkRanges: function (target, results) {
      target.benchmarksGraph.data.benchmarks.all.range = 'unavailable';
      target.benchmarksGraph.data.benchmarks.similar.range = 'unavailable';
    },

    ///////////////////
    // Seller Functions
    ///////////////////
    // Exposed only for testing and not intended for direct calls.
    _getFacilitiesForSeller: function (
      memberId,
      categoryId,
      rfpId,
      sellerId,
      priceType,
      duration,
      marketShare,
      usePrimaryCrossReferences
    ) {
      console.warn('TODO: Move the facilities API call to the api module');
      return $http
        .get('/aptitude/api/buyers/' + memberId + '/facilities', {
          params: {
            categoryId,
            isGroupRequest: false,
            rfpId,
            expand: 'savings',
            flattenHierarchy: true,
            priceType,
            duration,
            marketShare,
            sellerId,
            usePrimaryCrossReferences
          }
        })
        .then(function (results) {
          // Update numbers on the root
          fixNullCategorySpendNumbers(results[0]);

          _.each(results[0].children, fixNullCategorySpendNumbers);

          return results;
        }) as any;
    },

    getDataSetForSeller: function (rfpId) {
      var dataSets: any[] = [];
      var dataSet = {
        totalCount: null,
        aggregationGroupName: '',
        categoryName: '',
        categoryId: 0,
        requestId: rfpId,
        rfpType: null,
        pucks: [],
        overview: {
          marketShare: null,
          duration: {
            priceType: null,
            duration: null
          },

          totalCount: 0,

          notSavingCount: 0,

          totalSpend: 0,
          totalPotentialSpend: 0,

          targetPotentialMarketShare: 0,

          dials: {
            notSaving: {
              percentage: 0,
              number: 0,
              color: aptitudeNegativeColor
            },
            abilityToReachTarget: {
              percentage: 0,
              number: 0,
              numberIsPercentage: true,
              label: 'Target %',
              color: aptitudeNegativeColor
            }
          }
        }
      };
      dataSets.push(dataSet);

      // Get a handful of data we need to be able to display about the RFP (for example, it's category).
      var rfpDetailsPromise = this.getRfpDetails(rfpId).then(function (
        results
      ) {
        dataSet.aggregationGroupName = results.buyer.name;
        dataSet.categoryName = results.category.name;
        dataSet.categoryId = results.category.id;
        dataSet.rfpType = results.type;

        return results;
      });
      var participantsPromise = $http.get(
        '/aptitude/api/rfps/' + rfpId + '/participants'
      );
      console.warn('TODO: Move the participants API call to the api module');

      return $q
        .all([rfpDetailsPromise, participantsPromise])
        .then(function (resultsArray) {
          var results = resultsArray[1];

          dataSet.totalCount = results.totalCount;

          var includedMembers = _.filter(results.members, {
            included: true
          }) as any;

          _.each(includedMembers, (member: any) => {
            let puck = {
              name: member.profile.name,
              id: member.profile.id,

              // Used to know when to refresh facilities and benchmark data.
              dirty: true,

              savingsDisplay: {
                savingsAmount: 0
              },

              benchmarksGraph: {
                data: {
                  benchmarks: {
                    all: {
                      currentRanking: null,
                      plannedRanking: null,
                      range: 'loading' // loading, loaded, unavailable
                    },
                    similar: {
                      currentRanking: null,
                      plannedRanking: null,
                      range: 'loading' // loading, loaded, unavailable
                    }
                  },
                  savingsAmount: 0
                },
                config: {
                  benchmarkType: 'similar',
                  templateName: 'group-impact-details'
                }
              },

              facilities: []
            };

            dataSet.pucks.push(puck);
          });

          return dataSets;
        });
    },

    getResponseData: function (rfpId) {
      console.warn('TODO: Move the rfpresponses API call to the api module');
      return $http
        .get('/aptitude/api/rfps/' + rfpId + '/sellers/ME/rfpresponses')
        .then(function (results) {
          var retVal = {
            name: results.sellerName,
            id: results.sellerId,
            durationsOptions: []
          };

          // Generate all permutations of duration and price type.
          _.each(results.sellerTerms[0].duration, (duration: number) => {
            _.each(results.sellerTerms[0].priceType, (priceType) => {
              // Don't add disallowed combinations: 6 mo. variable and 12 mo. variable.
              if (
                !(
                  (duration === 6 || duration === 12) &&
                  priceType == 'Variable'
                )
              ) {
                retVal.durationsOptions.push({
                  label: duration + ' mo ' + priceType,
                  duration: duration,
                  priceType: priceType
                });
              }
            });
          });

          // Now we return the data to satisfy the promise we gave.
          return retVal;
        });
    },

    getPuckDetailsForSeller: function (
      puck,
      rfpId,
      sellerId,
      memberId,
      categoryId,
      priceType,
      duration,
      marketShare,
      usePrimaryCrossReferences
    ) {
      var target = puck;
      var self = this;

      if (puck.dirty) {
        // We won't need to re-get the facilities list or benchmark data until such time as the user runs a different
        // scenario.
        puck.dirty = false;

        puck.savingsPercentage = puck.plannedSpend
          ? Math.round((puck.savings / puck.continuedSpend) * 100.0)
          : 0;

        // Ask for facilities info for this particular puck.
        var facilitiesPromise = this._getFacilitiesForSeller(
          memberId,
          categoryId,
          rfpId,
          sellerId,
          priceType,
          duration,
          marketShare,
          usePrimaryCrossReferences
        ).then(function (facilities: any) {
          var parent = facilities[0];
          parent.categorySpend.spendWithSeller =
            parent.categorySpend.spendWithSeller || 0;
          target.facilities = facilities.concat(parent.children);

          // Get rid of null values for savings.
          _.each(parent.children, function (child: any) {
            child.categorySpend.spendWithSeller =
              child.categorySpend.spendWithSeller || 0;
          });
        });

        // Other puck details could change as the user market share and terms.
        var pricingPromise = this._getPricingBenchmarks(
          rfpId,
          'ME',
          memberId,
          priceType,
          duration,
          marketShare
        ).then(function (results) {
          target.benchmarksGraph = {
            data: {
              benchmarks: {
                all: {
                  currentRanking: results.ab_continuousCurrentSpend,
                  plannedRanking: results.ab_aptitudePlannedSpend
                },
                similar: {
                  currentRanking: results.sb_continuousCurrentSpend,
                  plannedRanking: results.sb_aptitudePlannedSpend
                }
              },
              savingsAmount: puck.savings
            },
            config: {
              benchmarkType: 'similar',
              templateName: 'group-impact-details'
            }
          };

          // Set the range indicators to let external code know whether we were able to get benchmark numbers or not
          // for each type of range.
          self._updateBenchmarksGraphWithBenchmarkRanges(target, results);
        });

        return $q.all([facilitiesPromise, pricingPromise]);
      } else {
        return $q.when(true);
      }
    },

    /**
     * When we have new values to put into the puck (for example, savings), this function handles copying it so that
     * code isn't repeated multiple times.
     *
     * @param puck
     * @param marketShare
     * @private
     */
    _assignMicroChartDataToPuck: function (puck, marketShare) {
      var index = marketShare / 10;
      var terms = puck.microChartData.marketTerms[0].pricingTerms[0];

      puck.continuedSpend = puck.microChartData.spendLast12Months;
      puck.plannedSpend = terms.minSpend ? terms.minSpend[index] : 0;
      puck.savings = -terms.min[index] || 0;
      puck.potentialMarketSharePercentage = terms.minAllocationPct
        ? terms.minAllocationPct[index]
        : 0;

      puck.conversionsNeededCount = terms.minNumberOfConversions
        ? terms.minNumberOfConversions[index]
        : 0;
    },

    /**
     * When we have new values to put into the seller overview, this function handles copying it so that the code isn't
     * repeated.
     *
     * @param dataSet
     * @param marketShare
     * @private
     */
    _assignMicroChartDataToOverview: function (dataSet, marketShare) {
      if (dataSet.microChartData) {
        dataSet.overview.dials.abilityToReachTarget.label =
          'Target ' + marketShare + '%';
      }
    },

    /**
     * When the user runs a scenario, this code figures out if it's a new scenario and if it is whether it can return
     * the results of that scenario just by looking at already cached data or if new API calls are needed. Then it
     * updates data structures with the new data.
     *
     * @param dataSet
     * @param rfpId
     * @param sellerId
     * @param priceType
     * @param duration
     * @param marketShare
     * @returns {Promise}
     */
    runScenario: function (
      dataSet,
      rfpId,
      sellerId,
      priceType,
      duration,
      marketShare,
      usePrimaryCrossReferences
    ) {
      var self = this;

      // If we've changed the price type or duration then we need to reload the price comparison data for all the pucks.
      if (
        priceType !== dataSet.overview.duration.priceType ||
        duration !== dataSet.overview.duration.duration ||
        !_.isBoolean(dataSet.overview.usePrimaryCrossReferences) ||
        usePrimaryCrossReferences !== dataSet.overview.usePrimaryCrossReferences
      ) {
        var deferred = $q.defer();

        // Record the price type, duration, and market share for later so we'll know if the user asks for something
        // different.
        dataSet.overview.duration.priceType = priceType;
        dataSet.overview.duration.duration = duration;
        dataSet.overview.marketShare = marketShare;
        dataSet.overview.targetPotentialMarketShare = parseInt(marketShare, 10);
        dataSet.overview.usePrimaryCrossReferences = usePrimaryCrossReferences;

        var allPromises: any[] = [];

        // Perform a price comparison for every puck. As each completes we can update the savings and market share
        // percentage.
        _.each(dataSet.pucks, function (puck: Puck) {
          puck.dirty = true;

          var promise = self._getPricingComparison(
            rfpId,
            'ME',
            puck.id,
            priceType,
            duration,
            usePrimaryCrossReferences
          );

          promise.then(function (results) {
            puck.microChartData = results;

            self._assignMicroChartDataToPuck(puck, marketShare);

            deferred.notify();
          });

          allPromises.push(promise);
        });

        // We also have to make an additional call to get pricing information for the group as a whole.
        self
          ._getPricingComparison(
            rfpId,
            'ME',
            null,
            priceType,
            duration,
            usePrimaryCrossReferences
          )
          .then(function (results) {
            dataSet.microChartData = results;

            self._assignMicroChartDataToOverview(dataSet, marketShare);
          });

        $q.all(allPromises).then(function () {
          deferred.resolve();
        });

        return deferred.promise;
      } else if (marketShare !== dataSet.overview.marketShare) {
        // Record this market share on the data set so we'll know if the user is asking for something different later.
        dataSet.overview.marketShare = marketShare;
        dataSet.overview.targetPotentialMarketShare = marketShare;

        // But if all we changed was the market share, we can get the savings and market share numbers from the data we
        // got previously.
        _.each(dataSet.pucks, function (puck: Puck) {
          puck.dirty = true;

          self._assignMicroChartDataToPuck(puck, marketShare);
        });

        self._assignMicroChartDataToOverview(dataSet, marketShare);
      }

      // Return a promise which will resolve immediately.
      return $q.when(true);
    }
  };
}
